import styled from 'styled-components';

export const ContentUserInfo = styled.div`
  display: flex;
  flex: wrap;
  justify-content: space-between;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const UserInfoPause = styled.span`
  font-size: 0.9rem;
  font-weight: bold;
  color: #5e72e4;
  font-weight: bold;
  padding-bottom: 0.5rem;

  span {
    color: #5e6a88;
  }
`;

export const Button = styled.button`
  border: 0;
  border-radius: 0.2rem;
  background-color: #5e72e4;
  width: 100%;
  height: 2.625rem;
  color: white;
  transition: 0.5s;
  font-family: Open Sans, sans-serif;
  &:hover {
    background-color: #36327f;
  }
`;

export const ContentLoading = styled.div`
  margin: 0 auto;
`;

export const RowSelect = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 1rem;
  margin-bottom: 1rem;
  gap: 1rem;
`;

export const TotalColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
export const ColInput = styled.div`
  display: flex;
  flex: 4;
  flex-direction: column;
`;

export const ColButton = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  justify-content: center;
`;
